import script from "./receivingsearch.vue?vue&type=script&lang=ts&setup=true"
export * from "./receivingsearch.vue?vue&type=script&lang=ts&setup=true"

import "./receivingsearch.vue?vue&type=style&index=0&id=cf363a7e&scoped=true&lang=less"
import "./receivingsearch.vue?vue&type=style&index=1&id=cf363a7e&lang=less"

import exportComponent from "D:\\projectLy\\2025伟本\\weben-les-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf363a7e"]])

export default __exports__